/*
 * La Biblioteca delle Emozioni — Checkout diretto (1 lettera per volta)
 * ---------------------------------------------------------------------
 * Intercetta l'invio del form prodotto (pulsante buy-buttons + pulsante sticky)
 * e, invece di aggiungere al carrello / aprire il drawer:
 *   1) svuota il carrello (per garantire una sola lettera per ordine)
 *   2) aggiunge questo prodotto con quantità 1
 *   3) porta l'utente direttamente al checkout
 *
 * Usa un listener in fase di CAPTURE + stopImmediatePropagation per scavalcare
 * l'handler add-to-cart del tema (universe-product-forms.js, che ascolta in bubble).
 */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ADD_URL = (window.routes && window.routes.cart_add_url) || ROOT + 'cart/add.js';
  var CLEAR_URL = (window.routes && window.routes.cart_clear_url) || ROOT + 'cart/clear.js';
  var CHECKOUT_URL = ROOT + 'checkout';

  function setLoading(form, on) {
    var btns = form.querySelectorAll('.js-product-form-submit, [type="submit"]');
    btns.forEach(function (b) {
      if (on) {
        b.classList.add('is-loading');
      } else {
        b.classList.remove('is-loading');
      }
    });
  }

  function showError(form, message) {
    var err = form.querySelector('.js-product-form-error');
    if (err) {
      err.classList.add('is-visible');
      err.innerText = message || 'Si è verificato un errore. Riprova.';
    }
  }

  function onSubmitCapture(event) {
    var form = event.currentTarget;

    // Se il pulsante è disabilitato (es. esaurito), lascia stare.
    var submit = form.querySelector('.js-product-form-submit');
    if (submit && submit.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    // Prendi il controllo: blocca sia il submit nativo sia l'handler del tema.
    event.preventDefault();
    event.stopImmediatePropagation();

    setLoading(form, true);

    var formData = new FormData(form);
    formData.set('quantity', 1); // una sola lettera

    // 1) svuota il carrello
    fetch(CLEAR_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    })
      // 2) aggiungi il prodotto
      .then(function () {
        return fetch(ADD_URL, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: formData,
        });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data && data.status) {
          // Errore restituito da /cart/add (es. non disponibile)
          setLoading(form, false);
          showError(form, data.description);
          return;
        }
        // 3) vai dritto al checkout
        window.location.href = CHECKOUT_URL;
      })
      .catch(function (e) {
        console.error('[direct-checkout]', e);
        setLoading(form, false);
        showError(form);
      });
  }

  function bind(form) {
    if (form.dataset.directCheckoutBound === 'true') return;
    form.dataset.directCheckoutBound = 'true';
    // true = fase di capture: precede l'handler in bubble del tema
    form.addEventListener('submit', onSubmitCapture, true);
  }

  function init() {
    document.querySelectorAll('.js-product-form').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
